import { Button, Input, InputRef, Modal, Popconfirm, Select, Space, Spin, Table, Tooltip, notification } from 'antd'
import React,{useEffect, useRef, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import { deTagSOW, fetchSOWRelations, fetchSowTagDetails, fetchSowTagValues, updateSowIdTagging } from '../../store/reducers/orderDashboardSlice';
import { checkAccess, getUserRole, rejectedApiMessage } from '../../utilities/CommonHelper';
import Highlighter from 'react-highlight-words';
import { ColumnType } from 'antd/es/table';
import { ColumnsType, FilterConfirmProps } from 'antd/es/table/interface';
import { SearchOutlined } from '@ant-design/icons';
import { getUserAccessData } from '../../utilities/sessionHelper';
import Link from 'antd/es/typography/Link';


interface DataType {
    key: React.Key;
    sowId: string;
    sowLink: string;
    clientEntity: string;
    // orderOwner: string;
    sowName: string;
    sowOwner: string;
    bu: string;
    // department: string;
    contractValue: string;
    sowStartDate: Date;
    sowEndDate: Date;
    salesSpoc: string;
    contractType: string;
    // currency: string;
    opportunityName: string;
    tagType: string;
  
  }

  type DataIndex = keyof DataType;

const TaggedSOWDetailsModal = (props:any) => {
  const dispatch = useDispatch();
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [sowDetailsData, setSowDetailsData] = React.useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);
  const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";
  const writeAccess_order:boolean=checkAccess(role,"Order Dashboard",getUserAccessData()?.roleAccessMap[role],"write");

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex] && record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<DataType> = [
    {
      title: 'SOW ID',
      width: 150,
      dataIndex: 'sowId',
      key: 'sowId',
      fixed: 'left',
      ...getColumnSearchProps('sowId'),
      render: (text: string, record: any, index:number) => {
        return(
          <>
          <a className='maplink' 
           href={record.contractLink} 
           target='_blank'>{text}</a>
           </>
        )
      }
    },
    {
      title: 'Tag',
      dataIndex: 'tagType',
      key: 'tagType',
      width: 150,
      ...getColumnSearchProps('tagType'),

    },
    {
      title: 'Client Entity',
      width: 150,
      dataIndex: 'clientEntity',
      key: 'clientEntity',
      ...getColumnSearchProps('clientEntity'),
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency',
      width: 150,
    },
    {
      title: 'Sow Name',
      dataIndex: 'sowName',
      key: 'sowName',
      width: 150,
      ...getColumnSearchProps('sowName'),
    },
    // {
    //   title: 'SOW Owner',
    //   dataIndex: 'sowOwner',
    //   key: 'sowOwner',
    //   width: 150,
  
    // },
    {
      title: 'Contract Value',
      dataIndex: 'contractValue',
      key: 'contractValue',
      width: 150,
      ...getColumnSearchProps('contractValue')
    },
    // {
    //   title: 'WO Value',
    //   dataIndex: 'woValue',
    //   key: 'woValue',
    //   width: 150,
    // },
    // {
    //   title: 'Pending WO Value',
    //   dataIndex: 'pendingWoValue',
    //   key: 'pendingWoValue',
    //   width: 150,
    // },
    {
      title: 'Contract Type',
      dataIndex: 'contractType',
      key: 'contractType',
      width: 150,
      ...getColumnSearchProps('contractType'),
    },
    // {
    //   title: 'SOW Start Date',
    //   dataIndex: 'sowStartDate',
    //   key: 'sowStartDate',
    //   width: 150,
    // },
    // {
    //   title: 'SOW End Date',
    //   dataIndex: 'sowEndDate',
    //   key: 'sowEndDate',
    //   width: 150,
    // },
    {
      title: 'Sales SPOC',
      dataIndex: 'salesSpoc',
      key: 'salesSpoc',
      width: 150,
      ...getColumnSearchProps('salesSpoc'),
    },
    {
      title: 'Action',
      dataIndex: 'bu',
      key: 'workOrders',
      width: 150,
      fixed: 'right',
      render: (text: string, record: any) => {
        return(
          <>
            <Tooltip title={!writeAccess_order && "Only Accessible by the Role : Finance" }>
              <Popconfirm title="Are you sure you want to detag this SOW?" onConfirm={()=>handleDetag(record)} okText="Yes" cancelText="No" disabled={!writeAccess_order}>
                <Link className='maplink' disabled={!writeAccess_order} onClick={()=>null}>DeTag</Link>
              </Popconfirm>
            </Tooltip>
          </>
        )
      }
    }
  ];


  useEffect(() => {
    if(props.visible){
      dispatch(fetchSOWRelations({sowId:props.selectedSOW.sowId, duplicate:props.tagType==="DUPLICATE"?true:false})).then((res:any)=>{
        if (res.type === 'orderDashboard/fetchSOWRelations/fulfilled') {
            if(res.payload && res.payload.length > 0){
                setSowDetailsData(res.payload);
        } 
      }
      else{
        rejectedApiMessage(res.payload);
      }
      });
    }
    else{
        setSowDetailsData([]);
    }
  },[props.visible]);


  const handleDetag = (record:any) => {
    dispatch(deTagSOW({sowId:record.sowId})).then((res:any)=>{
        if (res.type === 'orderDashboard/deTagSOW/fulfilled') {
            notification.success({
            message: 'Success',
            description: 'SOW Detagged successfully',
            });
            props.handleRefresh(true);
            dispatch(fetchSOWRelations({sowId:props.selectedSOW.sowId,duplicate:props.tagType==="DUPLICATE"?true:false})).then((res:any)=>{
            if (res.type === 'orderDashboard/fetchSOWRelations/fulfilled') {
                if(res.payload && res.payload.length > 0){
                    setSowDetailsData(res.payload);
                }
                else{
                    setSowDetailsData([]);
                } 
            }
            else{
            rejectedApiMessage(res.payload);
            }
            });
        } 
        else{
            rejectedApiMessage(res.payload);
        }
    })
  }
  
  return (
    <Modal
    title={props.tagType==="DUPLICATE"?"Tagged Duplicate SOWs":"Tagged SOW Details"}
    open={props.visible}
    onCancel={()=>props.onCancel()}
    footer={null}
    width={1400}
    styles={{
      content: {
        borderRadius: '0',
        borderTop: '4px solid #1677ff',
        font: 'normal normal normal 14px/20px Nunito Sans',
        zIndex: 9998,
      },
    }}
    >
    <Spin spinning ={orderDashboardData.loading }>
      <div>
        {props.tagType!=="DUPLICATE" &&<p>
          <b>Master SOW Id:</b> {props.selectedSOW.sowId}
        </p>}
        {props.tagType==="DUPLICATE" &&<p>
          <b>Original SOW Id:</b> {props.selectedSOW.sowId}
        </p>}
      </div>

      <Table 
      className='table-style'
      columns={columns} 
      dataSource={sowDetailsData} 
      scroll={{ x: 'max-content', y: 350}}
        // pagination={{
        //   current: pageNo + 1,
        //   pageSize,
        //   total: totalCount,
        // showSizeChanger: false,
        // }}
        // onChange={handleTableChange}
         />

    </Spin>
  </Modal>
  )
}
export default TaggedSOWDetailsModal;
